import { render, staticRenderFns } from "./ContactSupplier.vue?vue&type=template&id=3a7a079d&"
import script from "./ContactSupplier.vue?vue&type=script&lang=js&"
export * from "./ContactSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports